import React from "react";
import { Layer } from "react-konva";
import { TrackLabel } from "../TrackLabel";
import { Location } from "@opstel/query/models/location";

interface LabelLayerProps {
  readonly location: Location;
}
export function LabelLayer({ location }: LabelLayerProps): React.JSX.Element {
  return (
    <Layer>
      {location.tracks.map((track) => {
        if (track.length.inMillimeters() === 0) return;
        return (
          <TrackLabel
            onPointerOut={() => {}}
            onPointerOver={() => {}}
            key={track.code}
            text={track.name}
            trackCode={track.code}
            trackPoints={track.coordinates.fromSourceToTarget}
          />
        );
      })}
    </Layer>
  );
}
